import CreateIngredient from './CreateIngredient'
export default CreateIngredient
